import { ConfirmModal } from '@shared/components/Modals/ConfirmModal';

interface Props {
  isShowRemoveConfirmation: boolean;
  onCancel: () => void;
  onOk: () => void;
}

const ConfirmRemovePhotoModal = ({ isShowRemoveConfirmation, onCancel, onOk }: Props) => (
  <ConfirmModal
    cancelText="Cancel"
    descriptionTop="Are you sure you want to remove profile photo?"
    okText="Confirm"
    onCancel={onCancel}
    onOk={onOk}
    open={isShowRemoveConfirmation}
    title="Remove profile photo"
  />
);

export default ConfirmRemovePhotoModal;
